const Recipients = () => import("../recipients/views/Recipients.vue");
const RecipientEdit = () => import("../recipients/views/RecipientEdit.vue");

const route = "/recipients";

export default [
  {
    path: route,
    name: "recipients.list",
    component: Recipients,

    meta: {
      roles: ["ROLE_ADMIN"],
    },
  },

  {
    path: `${route}/create`,
    name: "recipients.create",
    component: RecipientEdit,

    meta: {
      roles: ["ROLE_ADMIN"],
    },
  },

  {
    path: `${route}/:recipientId/edit`,
    name: "recipients.edit",
    component: RecipientEdit,

    props: true,

    meta: {
      roles: ["ROLE_ADMIN"],
    },
  },
];
